export const TYPING_INDICATOR_UNIQUE_ID = 'typing-indicator-unique-id'
export const TYPING_INDICATOR_UNIQUE_PROPS_TYPE = 'typingIndicator'
